import type { DomainFormSchema } from '../schemas';
import { defaultHostingManagement, defaultRegistrarManagement } from '../schemas';

export const defaultValues: Readonly<DomainFormSchema> = {
  id: -1,
  name: '',
  dns_management: '',
  deployment_path: '',
  hosting_management: defaultHostingManagement,
  registrar_management: defaultRegistrarManagement,
  expiration_date: '',
  registrar_notes: '',
  hosting_notes: '',
  registrar_username: '',
  registrar_password: '',
  registrar_pin: '',
  registrar: null,
  infrastructure: null,
};
